import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBubbleCheck: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconBubbleCheck"><Path d="M9.19997 11.3L11 13.1L15.2 8.90001M3.5 3.5L20.5 3.50002V18.5H15.0155L11.9979 21L9.0155 18.5L3.5 18.5V3.5Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconBubbleCheck;
